import { T, hexA } from "./theme";
import type { impactBadge } from "@shared-domain/survey/presets";

// 影響有無バッジ (影響調査プリセット)。影響なし=緑丸+薄緑 / 影響あり=橙丸+薄橙。
// 一覧カード・完了/詳細画面で共用 (impactBadge() の戻り値 "no"|"yes" を渡す)。
export function ImpactBadge({ kind }: { kind: NonNullable<ReturnType<typeof impactBadge>> }) {
  const color = kind === "no" ? T.ok : T.warn;
  const label = kind === "no" ? "影響なし" : "影響あり";
  return (
    <span style={{ fontSize: 10, fontWeight: 700, color, background: hexA(color, 0.12), borderRadius: 9999, padding: "2px 9px", display: "inline-flex", alignItems: "center", gap: 5 }}>
      <span style={{ width: 7, height: 7, borderRadius: 9999, background: color, flex: "none" }} />{label}
    </span>
  );
}
